const SERVER_URL = "https://stabilix.co"
// const SERVER_URL = "http://localhost:3005"
const ADMIN_WALLET = "0xb278E26776CD49f4fab88380ACCAB8A5f3639aD1"
const TOKEN_CONTRACT = "0x0828b19D285634b2ea1F8020A0f2441B51a113E5"
const MORALIS_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJub25jZSI6IjkzZGRmNTM0LWZlMDUtNDcwOS1hZWFmLTQ0ZjcwYmZiZjYyMiIsIm9yZ0lkIjoiNDM5NzUwIiwidXNlcklkIjoiNDUyNDIxIiwidHlwZUlkIjoiYjlkOTBjZmMtNjc4Ny00MTE5LWFhZWYtZTlkNTRmMDkyYTIxIiwidHlwZSI6IlBST0pFQ1QiLCJpYXQiOjE3NDM4NTMxMzgsImV4cCI6NDg5OTYxMzEzOH0.HiRIpRwTsny8D2EkFw-bJzavTylwM1YqDdGrTOHDbaI'
const CHAIN = "avalanche";
const AVALANCHE_RPC = "https://green-little-slug.avalanche-mainnet.quiknode.pro/45c55038ba9f15cb43f2e64b557e1ec345f3bdef/ext/bc/C/rpc/";

const AVALANCHE_URL = 'https://snowtrace.io/address/';


module.exports = {
    SERVER_URL, ADMIN_WALLET, TOKEN_CONTRACT, MORALIS_API_KEY, CHAIN, AVALANCHE_URL,AVALANCHE_RPC
}
